module.exports = __webpack_public_path__ + "images/eurowheelz_small1c5b579d38d7329ab541929fda11fbae.png";